/**
 * The Quote link's strings (decision 2650; T1247): the public page the
 * customer answers with no login, the acceptance line on the Quote's page and
 * its History row, the optional mark the Item Table and the sheet draw, and
 * the optional lines in the accept window. Spread into the one lookup in
 * `strings.ts`, so `t()` stays the only way a screen reads text. 🔨 This file
 * imports nothing.
 */
export const QUOTE_LINK_STRINGS = {
  // The public page (decision 2650).
  'quoteLink.title': 'Your Quote',
  'quoteLink.reading': 'Opening your quote…',
  'quoteLink.notFound': 'This link can no longer be used. Ask whoever sent it to you for a new one.',
  'quoteLink.limited': 'Too many tries from this address. Try again in an hour.',
  'quoteLink.failed': 'The quote could not be reached. Try again in a moment.',
  'quoteLink.from': 'From',
  'quoteLink.for': 'For',
  'quoteLink.quoteDate': 'Quote date',
  'quoteLink.goodTill': 'Good till',
  'quoteLink.column.description': 'Description',
  'quoteLink.column.quantity': 'Qty',
  'quoteLink.column.unitPrice': 'Unit Price',
  'quoteLink.column.amount': 'Amount',
  'quoteLink.optional': 'Optional',
  'quoteLink.optionalHint': 'Tick each optional line you want included before you accept.',
  'quoteLink.include': 'Include',
  'quoteLink.subtotal': 'Sub Total',
  'quoteLink.tax': 'Tax',
  'quoteLink.total': 'Total',
  'quoteLink.pdf': 'View PDF',
  'quoteLink.accept.title': 'Accept This Quote',
  'quoteLink.accept.name': 'Your full name',
  'quoteLink.accept.hint': 'Typing your name records that you accept this quote, with the time and the address you sent it from.',
  'quoteLink.accept.action': 'Accept',
  'quoteLink.accept.sending': 'Accepting…',
  'quoteLink.accept.needsName': 'Type your full name to accept.',
  'quoteLink.accept.nameTooLong': 'A name is 120 characters at most.',
  'quoteLink.decline.title': 'Not Going Ahead?',
  'quoteLink.decline.reason': 'Reason (optional)',
  'quoteLink.decline.action': 'Decline',
  'quoteLink.decline.sending': 'Declining…',
  'quoteLink.decline.reasonTooLong': 'A reason is 1,000 characters at most.',
  'quoteLink.acceptedNow': 'Thank you. Your acceptance is recorded, and we will be in touch.',
  'quoteLink.declinedNow': 'Thank you. Your answer is recorded.',
  'quoteLink.acceptedBy': 'Accepted by {name} on {date}.',
  // Where a link stands, when it offers no control.
  'quoteLink.state.open': 'This quote is open for your answer.',
  'quoteLink.state.accepted': 'This quote was accepted.',
  'quoteLink.state.declined': 'This quote was declined.',
  'quoteLink.state.expired': 'This quote is past its good-till date. Ask whoever sent it for a new one.',
  'quoteLink.state.void': 'This quote was withdrawn.',
  'quoteLink.state.superseded': 'A newer copy of this quote was sent to you. Open the link in the newest mail.',
  'quoteLink.state.closed': 'This quote cannot be answered here. Ask whoever sent it to you.',
  // The Quote's page and its History (decision 2650).
  'quote.acceptance.link': 'Accepted from the emailed link by {name} on {date} from {address}',
  'quote.acceptance.linkNoAddress': 'Accepted from the emailed link by {name} on {date}',
  'quote.acceptance.recorded': 'Accepted, recorded by {name} on {date}',
  'quote.acceptance.optional': 'Optional lines taken: {taken} of {total}',
  'quote.history.linkAccepted': 'Accepted from the emailed link by {name} from {address}',
  'quote.history.linkAcceptedNoAddress': 'Accepted from the emailed link by {name}',
  'quote.history.recorded': 'Accepted, recorded by {name}',
  'quote.history.linkDeclined': 'Declined from the emailed link from {address}',
  'quote.history.linkDeclinedNoAddress': 'Declined from the emailed link',
  // The optional mark, its totals and the accept window (decision 2650).
  'item.optional': 'Optional',
  'item.optionalHint': 'The customer may take or leave an optional line, and only the lines taken carry to the order.',
  'quote.lines.optionalTotal': 'Optional Lines',
  'quote.lines.allOptions': 'Total with All Options',
  'quote.lines.acceptedTotal': 'Accepted Total',
  'quote.accept.optionalHeading': 'Optional lines the customer took',
  'document.print.optionalMark': 'Optional',
  'document.print.optionalLines': 'Optional Lines',
  'document.print.allOptions': 'Total with All Options',
} as const;
